import { getServer } from "@translations/next";
import DinningContainer from "@containers/DinningContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import Layout from "@components/Layout";
import StrapiService from "@services/StrapiService";
import _ from "lodash";
import FooterService from "@services/FooterService";

export default function About(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <DinningContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

// export { getServerSideProps };
export const getServerSideProps = getServer(async ({ params }: any) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel10-dining-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);
  return {
    hotel: "amanaki-thao-dien",
    pageData: _.get(res, "data", {}),
    footerData,
  };
});
